import React, { useEffect, useState } from 'react';
import { ControlLabel, FormControl } from 'react-bootstrap';

import PenService from 'services/PenService';

interface RateBookCode {
  Code: string;
  Description: string;
}

interface Props {
  productId: number;
  providerDealerCode?: string;
  productDealerCode?: string;
  dealerId: string;
  setShowSpinner: (showSpinner: boolean) => void;
  setPenError: (err: string | null) => void;
  rateBookCode?: string;
  setRateBookCode: (code: string | null) => void;
  lookupDisabled: boolean;
  setIsPreSelected: (val: boolean) => void;
}

export const SERVICE = {
  registerProduct: PenService.registerProduct,
  getRateBookCodes: PenService.getRateBookCodes,
};

function useLogic({
  productId,
  providerDealerCode,
  productDealerCode,
  dealerId,
  rateBookCode,
  setShowSpinner,
  setPenError,
  setRateBookCode,
  setIsPreSelected,
}: Props) {
  const [availableCodes, setAvailableCodes] = useState<RateBookCode[]>([]);

  // when productId changes, allow interaction with this component
  useEffect(() => {
    setIsPreSelected(false);
    setAvailableCodes([]);
    setRateBookCode(null);
  }, [productId]);

  useEffect(() => {
    if (rateBookCode && productId) {
      setIsPreSelected(true);
      loadRateBookCodes();
      return;
    }

    setAvailableCodes([]);
    setRateBookCode(null);
  }, [dealerId, providerDealerCode, productDealerCode, setRateBookCode]);

  const loadRateBookCodes = async () => {
    setShowSpinner(true);
    try {
      await SERVICE.registerProduct({
        dealerId,
        productId,
        providerDealerCode,
        productDealerCode,
      });
      const codes = await SERVICE.getRateBookCodes({ dealerId, productId });
      setPenError(null);
      setAvailableCodes(codes);
      if (codes.length) {
        setRateBookCode(codes[0].Code);
      }
    } catch (e) {
      // @ts-expect-error catch must be `any | unknown`, but prettier removes `any`
      setPenError(e.error);
    } finally {
      setShowSpinner(false);
    }
  };
  return {
    availableCodes,
    loadRateBookCodes,
  };
}

export function SelectRateBookCode(props: Props) {
  const [isPreSelected, setIsPreSelected] = useState(false);
  const { availableCodes, loadRateBookCodes } = useLogic({
    ...props,
    setIsPreSelected,
  });

  const renderLoadButton = () => {
    if (availableCodes && availableCodes.length) {
      return null;
    }
    return (
      <button
        type="button"
        className="btn btn-primary"
        disabled={props.lookupDisabled}
        onClick={loadRateBookCodes}
      >
        Get Rate Book Codes
      </button>
    );
  };
  const renderSelectInput = () => {
    if (!availableCodes || !availableCodes.length) {
      return null;
    }
    return (
      <div>
        <ControlLabel>Rate Book Code*</ControlLabel>
        <FormControl
          name="rateBookCode"
          componentClass="select"
          disabled={isPreSelected}
          onChange={
            // eslint-disable-next-line  @typescript-eslint/no-explicit-any
            (e: any) => props.setRateBookCode(e.target.value)
          }
        >
          {availableCodes.map(({ Code, Description }) => (
            <option value={Code} key={Code}>
              {Description}
            </option>
          ))}
        </FormControl>
      </div>
    );
  };
  return (
    <div className="row col-sm-3 pb-15">
      {renderLoadButton()}
      {renderSelectInput()}
    </div>
  );
}

export const test = {
  useLogic,
};
